module.exports = __webpack_public_path__ + "static/media/cvc.04883db9.png";